import { SET_TEXT_VALIDATION, CLEAR_TEXT_VALIDATION } from 'store/key';
import { produce } from 'utility/general';

const initialState = {};

export const setTextValidation = (data) => ({
    type: SET_TEXT_VALIDATION,
    payload: data,
});

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_TEXT_VALIDATION:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        case CLEAR_TEXT_VALIDATION:
            return {};
        default:
            return state;
    }
};
export default reducer;
